export default class UpdateNoteModel {
  constructor(data = {}) {
    this.id = data.id;
    this.note = data.note;
  }
}
